import { EventAction } from '../EventAction';
import { catchAction } from '../EventReceiver';
import { getService } from 'data/function';
import { ChangeSubheaderTitleEvent } from 'modules/navbar/subheader/SubheaderListController';
export class NavbarProcessor {
    static get $rootScope() {
        return getService('$rootScope');
    }
    static process({ message }) {
        switch (catchAction(message.action)) {
            case EventAction.HideNavbar:
                document.getElementById('main-navbar').classList.add('dn');
                break;
            case EventAction.ShowNavbar:
                document.getElementById('main-navbar').classList.remove('dn');
                break;
            case EventAction.ChangeSubheaderTitle:
                this.$rootScope.$emit(ChangeSubheaderTitleEvent, message.content);
                break;
        }
    }
}
